import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=192538d4&scoped=true"
import script from "./MainList.vue?vue&type=script&lang=js"
export * from "./MainList.vue?vue&type=script&lang=js"
import style0 from "./MainList.vue?vue&type=style&index=0&id=192538d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192538d4",
  null
  
)

export default component.exports